import { Stack } from '@mui/material';
import { memo } from 'react';
import { SelloutModalContentProps } from '../../modal/types/selloutModalContent.types';
import SelloutLeftColumns from './leftColumns/components/SelloutLeftColumns';
import SelloutTable from './table/components/SelloutTable';

interface SelloutModalContentDesktopProps extends SelloutModalContentProps {}

const SelloutModalContentDesktop = ({
  pieces,
  disabled,
  distribution,
  selloutProductColor,
  onChangePieces,
}: SelloutModalContentDesktopProps) => {
  return (
    <Stack direction="row" spacing="24px">
      <SelloutLeftColumns
        pieces={pieces}
        disabled={disabled}
        selloutProductColor={selloutProductColor}
        onChangePieces={onChangePieces}
      />

      <SelloutTable
        pieces={pieces}
        disabled={disabled}
        distribution={distribution}
        selloutProductColor={selloutProductColor}
        onChangePieces={onChangePieces}
      />
    </Stack>
  );
};

export default memo(SelloutModalContentDesktop);
